import { render, staticRenderFns } from "./TreatmentMatrixUnpavedList.vue?vue&type=template&id=f1a57630&scoped=true"
import script from "./TreatmentMatrixUnpavedList.vue?vue&type=script&lang=js"
export * from "./TreatmentMatrixUnpavedList.vue?vue&type=script&lang=js"
import style0 from "./TreatmentMatrixUnpavedList.vue?vue&type=style&index=0&id=f1a57630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a57630",
  null
  
)

export default component.exports